<ng-container
    *tuiLet="{
        mergeCells: canMergeCells$ | async,
        splitCells: canSplitCells$ | async
    } as can"
>
    <button
        *ngIf="texts$ | async as texts"
        tuiIconButton
        type="button"
        size="s"
        appearance="icon"
        tuiHintDirection="top-left"
        tuiHintDescribe
        [icon]="can.mergeCells ? 'tuiIconTableMergeLarge' : 'tuiIconTableSplitLarge'"
        [tuiHint]="can.mergeCells ? texts.mergeCells : texts.splitCells"
        [focusable]="false"
        [disabled]="!can.mergeCells && !can.splitCells"
        (click)="can.mergeCells ? mergeCells() : splitCell()"
    ></button>
</ng-container>
